<template>
  <transition name="el-fade-in-linear">
	<div v-show="transitionshow">      
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small" filterable clearable :style="maxheight">
	  	  <el-form-item style="width:12%">
			  <el-select v-model="query.activestatus" @change="query.ischange=true" clearable placeholder="请选择活动状态">
					<el-option v-for="(item,index) in activestatuslists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select>
		  </el-form-item>	
	  	  <el-form-item style="width:8%">
			  <el-select v-model="query.isjoin" @change="query.ischange=true" clearable placeholder="请选择是否参加活动">
					<el-option v-for="(item,index) in joinlists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select>
		  </el-form-item>
		  <el-form-item style="width:8%">
			  <el-select v-model="query.activetype" @change="query.ischange=true" clearable placeholder="请选择活动类型">
					<el-option v-for="(item,index) in activetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select>
		  </el-form-item>
		  <el-form-item style="width:12%">
			  <el-select v-model="query.timetype" @change="query.ischange=true" placeholder="请选择活动时间类型">
					<el-option v-for="(item,index) in timelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select>
		  </el-form-item>
		  <el-form-item style="width:25%">
			  <el-date-picker	v-model="query.date" type="daterange" style="width:100%"
				  range-separator="至"
				  start-placeholder="报名/活动开始日期"
				  end-placeholder="报名/活动结束日期"
				  value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
			  </el-date-picker>
		  </el-form-item>
		  <el-form-item ref="query.key" :model="query">
			  <el-input placeholder="请输入活动名称" v-model="query.key" clearable @change="ischange=true" style="width:100%" @keyup.enter.native="searchorder"></el-input>
		  </el-form-item>
		  <el-form-item>
			  <el-button size="small" type="primary" icon="el-icon-search" @click="getsysofferlists">搜索</el-button>
		  </el-form-item>
	  </el-form>

	  <div class="backborder2" style="margin-top:10px">
		  <div class="sys-offers-out" v-loading="query.loading">

			<a class="sys-offers-in-click" @click="goactiveinfos(item)" v-for="(item,index) in activelists" :key="index">
		    <div class="sys-offers-in">
			  <div class="sys-offers-in-cover" v-if="(item.joinstatus==1) || (item.activestatus==1 && item.joinstatus==3) ||  (item.activestatus==3)">
			  	  <div class="sys-offers-in-cover-label" v-if="item.joinstatus==1">报名未开始</div>
				  <div class="sys-offers-in-cover-label" v-if="item.activestatus==1 && item.joinstatus==3">报名已结束，活动未开始</div>
			  	  <div class="sys-offers-in-cover-label" v-if="item.activestatus==3">活动已结束</div>
			  </div>
			  <div class="sys-offers-in-label" v-if="item.label!=''">{{item.label}}</div>
			  <div class="sys-offers-in-main">
				<div class="sys-offers-in-main-left">
					<div class="sys-offers-in-main-name">
						<i class="sys-offers-in-name-title" v-if="item.type==1">新人专享</i>
						<i class="sys-offers-in-name-title" v-if="item.type==4">限时秒杀</i>
						<i class="sys-offers-in-name-title" v-if="item.type==3">特卖活动</i>
						<i class="sys-offers-in-name-title" v-if="item.type==6">新品促销</i>
						{{item.name}}
					</div>
					<div class="sys-offers-in-main-time">报名时间：{{item.jointime}}</div>
					<div class="sys-offers-in-main-time" style="border-bottom:1px dashed #666666;padding-bottom:5px">活动时间：{{item.activetime}}</div>
					<div class="sys-offers-in-main-time" style="margin-top:5px">
						<span>商品状态：待审核 
							  <i class="sys-offers-status">{{item.readygoods}}</i>个，通过 
							  <i class="sys-offers-status">{{item.passgoods}}</i>个，失败 
							  <i class="sys-offers-status">{{item.failgoods}}</i>个
						</span>
					</div>
					<div class="sys-offers-in-main-time">参加时间：{{item.myjointime=='' ? '未参加' : item.myjointime}}</div>
				</div>
				<div class="sys-offers-in-main-right">
				   <el-button size="mini" round @click.stop="activejoin(item)">去报名</el-button>
				</div>
			  </div>
			</div>
			</a>				
			
		  </div>
		  <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="PageSizeChange"
		            @current-change="PageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="activerows">
	            </el-pagination>
	            <!--分页end-->
	      </div>	  
	  </div>



	  <!-- 平台活动详情 -->
	  <el-dialog title="活动信息明细" :visible.sync="activequery.dialog" width="80%" top="10vh">
		  <div class="sys-offers-details-main" v-loading="activequery.loading">
		  	  <div class="sys-offers-details-main-line"></div>
			  <div class="sys-offers-details-main-title">基本信息</div>
			  <div class="sys-offers-details-main-content">
				<div class="sys-offers-details-main-content-info">
					<span>活动名称：</span>
					<span v-if="activequery.type==1">新人专享 - </span>
					<span v-if="activequery.type==4">限时秒杀 - </span> 
					<span v-if="activequery.type==3">特卖活动 - </span> 
					<span v-if="activequery.type==6">新品促销 - </span>  
					<span>{{activequery.name}}</span>
				</div>
				<div class="sys-offers-details-main-content-info">
					<span>平台统一价格：</span> 
					<span>{{activequery.unified}}</span>
				</div>
				<div class="sys-offers-details-main-content-info">
					<span>报名时间：{{activequery.jointime}} </span>
					<i class="sys-offers-details-main-content-info-status1" v-if="activequery.joinstatus==1">未开始</i>
					<i class="sys-offers-details-main-content-info-status2" v-if="activequery.joinstatus==2">进行中</i>
					<i class="sys-offers-details-main-content-info-status3" v-if="activequery.joinstatus==3">已结束</i>
				</div>
				<div class="sys-offers-details-main-content-info">
					<span>活动时间：{{activequery.activetime}}</span> 
					<span v-if="activequery.cuteverystarttime!=''" style="color:#F56C6C">（活动期间每天 {{activequery.cuteverystarttime}}开始，{{activequery.cuteveryendtime}} 结束）</span>
					<i class="sys-offers-details-main-content-info-status3" v-if="activequery.activestatus==1">未开始</i>
					<i class="sys-offers-details-main-content-info-status2" v-if="activequery.activestatus==2">进行中...</i>
					<i class="sys-offers-details-main-content-info-status3" v-if="activequery.activestatus==3">已结束</i>
				</div>
				<div class="sys-offers-details-main-content-info" v-if="activequery.verifyerstatus==3">
					<span>失败原因：{{activequery.reason}} </span>
				</div>
				<div class="sys-offers-details-main-content-info">参加时间：{{activequery.myjoindate=='' ? '未参加' : activequery.myjoindate}}</div>
				<div class="sys-offers-details-main-content-info">活动介绍：<el-button size="small" round @click="checkintroduction">查看</el-button></div>
			  </div>
		  </div>

		  <div class="sys-offers-details-main" v-loading="activequery.loading">
		  	  <div class="sys-offers-details-main-line"></div>
			  <div class="sys-offers-details-main-title">活动统计</div>
			  <div class="sys-offers-details-main-content">
				<div class="sys-offers-details-main-content-info1">参加活动商品数量：{{activequery.stats.statgoodsnums}}</div>
				<div class="sys-offers-details-main-content-info1">成交商品数：{{activequery.stats.salegoodsnums}}</div>
				<div class="sys-offers-details-main-content-info1">成交订单数：{{activequery.stats.ordernums}}</div>
				<div class="sys-offers-details-main-content-info1">下单店铺数：{{activequery.stats.saleshops}}</div>
				<div class="sys-offers-details-main-content-info1">实收金额数：{{activequery.stats.salereals}}</div>
			  </div>
		  </div>

		  <div class="sys-offers-details-main" v-loading="activegoodsquery.loading">
		  	  <div class="sys-offers-details-main-line"></div>
			  <div class="sys-offers-details-main-title"><span>活动商品</span></div>

			  <div style="width:100%;margin-top:20px;" v-if="activequery.activestatus==2">
			  	  <el-button type="danger" size="small" @click="offergoodsmoredown">提前下架选中商品</el-button>
				  <el-button type="danger" size="small" @click="offergoodsalldown">下架所有商品</el-button>
			  </div>

			  <el-table :data="activegoods" style="margin-top:10px" border="1" ref="joingoodstable">
			  	<el-table-column type="selection" width="60" fixed="left" />
				<el-table-column label="sku" width="120" fixed="left">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="380" fixed="left">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">
								{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}
							</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')" />
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="审核结果" width="130" align="center">
					<template slot-scope="scope">
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==1">待审核</span>
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==2">通过</span>
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==3">失败</span>
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==3 && scope.row.reason!=null && scope.row.reason!=''" style="color:#F56C6C">{{scope.row.reason}}</span>
					</template>
				</el-table-column>
				<el-table-column label="所属品牌" align="center" width="140">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.brandname}}</span>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==1">未授权</i>
						<i class="sys-offers-details-brand-grant-yes" v-if="scope.row.brandname!='' && scope.row.brandtype==2">已授权</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==3">授权失败</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==4">授权未开始</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==5">授权到期</i>
					</template>
				</el-table-column>
				<el-table-column label="销售价格" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.property_price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="活动价" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.active_price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="成交数量 / 投放数量 / 可用库存数量" align="center" width="230">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.inventory}}</span>
					</template>
				</el-table-column>
				<el-table-column label="成交订单数" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.ordersnum}}</span>
					</template>
				</el-table-column>
				<el-table-column label="成交店铺数" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.shopnums}}</span>
					</template>
				</el-table-column>
				<el-table-column label="实收金额" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.reals}}</span>
					</template>
				</el-table-column>
				<el-table-column label="提前结束时间" align="center" width="170">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.canneltime}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button size="small" round v-if="scope.row.canneltime=='-' && activequery.activestatus==2" @click="offergoodsdown(scope.row)">提前下架</el-button>
					</template>
				</el-table-column>
			  </el-table>

			  <div class="block">
		      <!--分页begin-->
		      <el-pagination 
			  	  @size-change="goodspageSizeChange" 
				  @current-change="goodspageCurrentChange"
		      	  :current-page="activegoodsquery.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="activegoodsquery.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="activerows">
		      </el-pagination>
		      <!--分页end-->
	      	  </div>

		  </div>

		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="activequery.dialog = false" style="margin-top:20px">取 消</el-button>
          </div> 
	  </el-dialog>


	  <!-- 活动详情介绍 -->
	  <el-dialog title="活动详情介绍" :visible.sync="showintroductionDialog" width="50%" top="10vh">
		  <div v-html="activequery.content"></div>
		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="showintroductionDialog = false" style="margin-top:30px">取 消</el-button>
          </div> 
	  </el-dialog>


  </div>
  </transition>  
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"SysOffers/index",
        actionauth:'', //功能权限
		transitionshow:true,
		query: {
			act:'getsysofferslists',
			token:this.$cookies.get('token'),
			isjoin:'',
			activestatus:1,
			activetype:'',
			timetype:2,
			date:[],
			key:'',
			ischange:false,
			loading:false,
			p:1,
			rollpage:20,
		},
		activelists:[],
		activerows:0,


		joinlists:[{id:1,name:'已报名'},{id:2,name:'未报名'}],
		activetypelists:[{id:1,name:'新人专享'},{id:4,name:'限时秒杀'},{id:3,name:'特卖活动'},{id:8,name:'新品促销'}],
		timelists:[{id:2,name:'按报名时间搜索'}],
		activestatuslists:[{id:1,name:'未结束'},{id:2,name:'已结束'}],

		showintroductionDialog:false,
		activequery: {
			act:'getactiveinfos',
			token:this.$cookies.get('token'),
			id:'',
			name:'',
			type:'',
			content:'',
			activetime:'',
			jointime:'',
			myjoindate:'',
			reason:'',
			verifyerstatus:'',
			unified:'',
			cuteverystarttime:'',
			cuteveryendtime:'',
			stats:{statgoodsnums:0,salegoodsnums:0,ordernums:0,saleshops:0,salereals:0},
			goods:[],
			loading:false,
			dialog:false,
		},

		activegoodsquery: {
			act:'getactivegoodsinfos',
			token:this.$cookies.get('token'),
			id:'',
			brandid:'',
			key:'',
			ischange:false,
			loading:false,
			p:1,
			rollpage:10,
		},
		activegoods:[],
		activerows:0,




		
    }
  },

  watch: {
	  childdata(val) {
		  if(val.issysoffersnew==1) this.getsysofferlists(); //刷新列表数据
	  },
  },
    
  mounted(){  
    this.getactionauth();
	this.getsysofferlists(); //获取平台活动信息列表
  },
  
  methods:{


	/** 点击下架活动商品信息 **/
	offergoodsdown(item) {
		this.$confirm('该操作将使该商品提前结束活动且不能再重复上架，是否确定 ？', { type: 'warning' }).then(() => {
			var resource = this.$resource(this.url);
			resource.save({act:'downactivegoods',ids:item.offerdetailid,offerid:this.activequery.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.goactiveinfos({id:this.activequery.id});
				}
			}).catch((res) => {
				
			});		  
		}).catch(() => {
								
		});
	},

	/** 下架选中商品 **/
	offergoodsmoredown() {
		var result=this.$refs.joingoodstable.selection; var ids=[];
		result.forEach(function(e,i) {ids.push(e.offerdetailid)});
		if(ids.length==0) {this.$message.error('请选择需要提前下架的商品');return false;}

		this.$confirm('该操作将使已选中的商品提前结束活动且不能再重复上架，是否确定 ？', { type: 'warning' }).then(() => {
			var resource = this.$resource(this.url);
			resource.save({act:'downactivegoods',ids:ids.join(','),offerid:this.activequery.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.goactiveinfos({id:this.activequery.id});
				}
			}).catch((res) => {
				
			});		  
		}).catch(() => {
								
		});
		
	},

	/** 下架全部商品 **/
	offergoodsalldown() {
		this.$confirm('该操作将使全部商品提前结束活动且不能再重复上架，是否确定 ？', { type: 'warning' }).then(() => {
		var resource = this.$resource(this.url);
		resource.save({act:'downactivegoods',type:'all',offerid:this.activequery.id,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.goactiveinfos({id:this.activequery.id});
				}
			}).catch((res) => {
				
			});		  
		}).catch(() => {
								
		});
	},


	/** 查看活动介绍 **/
	checkintroduction() {
		this.showintroductionDialog=true;
	},


    /** 获取平台活动信息列表 **/
	getsysofferlists() {
		if(this.query.ischange) {
			this.query.p=1;
			this.query.rollpage=20;
		}
		this.query.loading=true;
		var resource = this.$resource(this.url);
		resource.save(this.query).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.query.loading=false;
			}else{
				this.activelists = JSON.parse(Base64.decode(res.data.Data));
				this.activerows=parseInt(res.data.count);
				this.query.loading=false;
				if(this.query.ischange) this.query.ischange=false;

			}
		}).catch((res) => {
			this.query.loading=false;
		});
	},
	PageSizeChange(val) {
        this.query.rollpage = val;
        this.getsysofferlists();
    },
    PageCurrentChange(val) {
        this.query.p = val;
        this.getsysofferlists();
    }, 


    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },


	/** 活动详情 **/
	goactiveinfos(item) {
		this.activequery.loading=true;
		this.activequery.dialog=true;

		this.activequery.id=item.id;
		var resource = this.$resource(this.url);
		resource.save(this.activequery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.activequery.loading=false;
			}else{
				var result = JSON.parse(Base64.decode(res.data.Data));
				this.activequery.loading=false;

				this.activequery.name=result.name;
				this.activequery.type=result.type;
				this.activequery.content=result.content;
				this.activequery.activetime=result.activetime;
				this.activequery.jointime=result.jointime;
				this.activequery.myjoindate=result.myjoindate;
				this.activequery.reason=result.reason;
				this.activequery.verifyerstatus=result.verifyerstatus;

				this.activequery.activestatus=result.activestatus;
				this.activequery.joinstatus=result.joinstatus;
				this.activequery.jointype=result.jointype;
				this.activequery.unified=result.unified;
				this.activequery.cuteverystarttime=result.cuteverystarttime;
				this.activequery.cuteveryendtime=result.cuteveryendtime;

				this.activequery.stats.statgoodsnums=result.stats.statgoodsnums;
				this.activequery.stats.salegoodsnums=result.stats.salegoodsnums;
				this.activequery.stats.ordernums=result.stats.ordernums;
				this.activequery.stats.saleshops=result.stats.saleshops;
				this.activequery.stats.salereals=result.stats.salereals;
				this.activequery.loading=false;

				this.getactivegoods(item.id);

			}
		}).catch((res) => {
			this.activequery.loading=false;
		});
		
	},


	/** 获取平台活动商品信息 **/
	getactivegoods(id) {
		this.activegoodsquery.id=id;
		this.activegoodsquery.brandid='';
		this.activegoodsquery.key='';
		this.activegoodsquery.p=1;
		this.activegoodsquery.rollpage=10;
		this.activegoods=[];
		this.activerows=0;
		this.getactivegoodsdata();
	},

	/** 获取平台活动商品数据 **/
	getactivegoodsdata() {
		if(this.activegoodsquery.ischange) {
			this.activegoodsquery.p=1;
			this.activegoodsquery.rollpage=10;
		}
		this.activegoodsquery.loading=true;
		var resource = this.$resource(this.url);
		resource.save(this.activegoodsquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.activegoodsquery.loading=false;
			}else{
				this.activegoods = JSON.parse(Base64.decode(res.data.Data));
				this.activerows = parseInt(res.data.count);
				if(this.activequery.ischange) this.activequery.ischange=false;
				this.activegoodsquery.loading=false;
			}
		}).catch((res) => {
			this.activegoodsquery.loading=false;
		});
	},
	goodspageSizeChange(val) {
        this.activegoodsquery.rollpage = val;
        this.getactivegoodsdata();
    },
    goodspageCurrentChange(val) {
        this.activegoodsquery.p = val;
        this.getactivegoodsdata();
    },


    
	/** 查看当前条件是否满足去报名的操作 **/
	activejoin(item) {
		var resource = this.$resource(this.url);
		resource.query({act:'checksysactivejoins',id:item.id,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				var result = JSON.parse(Base64.decode(res.data.Data));
				this.$emit('listenchild',{name:'平台营销活动报名',url:'Sysoffersjoin',data:{sysactid:item.id,jointype:item.verifyerstatus,sysactivejoinfresh:true}});
			}
		}).catch((res) => {
			
		});
	},


   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.sys-offers-out {width:100%;margin-top:20px;position:relative;display:inline-block;}
.sys-offers-in {width:100%;float:left;position:relative;margin-top:10px;margin-bottom:10px;transition:.3s all}
.sys-offers-in:nth-child(3n+3) {margin-right:0}
.sys-offers-in-cover {position:absolute;width:100%;height:100%;background:rgba(0,0,0,.8);border-radius:15px;border:1px solid rgba(0,0,0,.8);z-index:100;text-align:center;transition:opacity .5s;}
.sys-offers-in:hover .sys-offers-in-cover {opacity:0;z-index:0}
.sys-offers-in-cover-label {color:#666666;background:rgba(255,255,255,1);font-size:13px;line-height:23px;padding:5px 5%;border-radius:30px;max-width:40%;margin:63px auto 0 auto;display:inline-block}
.sys-offers-in-label {position:absolute;left:94%;background:#F56C6C;color:#fff;padding:2px 10px;font-size:12px;border-radius:15px;text-align:center;line-height:18px;width:8%;z-index:10;top:-5px}
.sys-offers-in-main {float:left;width:94%;padding:10px 3%;border-radius:15px;position:relative;transition:.3s all;border:1px solid #dddddd;box-shadow:5px 5px 10px rgba(0,0,0,.2);background:#fff}
.sys-offers-in-main-left {float:left;width:77%;}
.sys-offers-in-main-name {float:left;width:100%;font-size:13px;font-weight:450px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;margin:5px 0 5px 0;color:#333333}
.sys-offers-in-main-time {float:left;width:100%;font-size:12px;font-weight:450px;line-height:22px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:1px;color:#666666}
.sys-offers-in-main-right {float:left;width:22%;margin-left:1%;text-align:center;margin-top:50px}
.sys-offers-in-name-title {font-style:normal;font-size:12px;background:rgb(103, 194, 58);padding:4px 10px;border-radius:15px;color:#fff;margin-right:2%}
.sys-offers-in-click {cursor:pointer;display:inline-block;width:30%;margin-right:3%}

.sys-offers-details-main {width:100%;display:inline-block;margin-bottom:100px}
.sys-offers-details-main-line {display:inline-block;width:1%;height:20px;background:#e6a23c;border-radius:15px;top:5px;position:relative}
.sys-offers-details-main-title {display:inline-block;font-size:15px;font-weight:500;line-height:15px;padding:5px 0;margin-left:.5%;position:relative}
.sys-offers-details-main-content {display:inline-block;font-size:14px;font-weight:400;line-height:14px;width:98%;margin-left:2%;margin-top:20px}
.sys-offers-details-main-content-info {display:inline-block;font-size:13px;font-weight:400;line-height:28px;width:100%;margin:5px 0}
.sys-offers-details-main-content-info-status1 {color:#fff;padding:2px 10px;border-radius:15px;background:rgb(230, 162, 60);margin-left:2px;font-size:12px;font-style:normal}
.sys-offers-details-main-content-info-status2 {color:#fff;padding:2px 10px;border-radius:15px;background:rgb(103, 194, 58);margin-left:2px;font-size:12px;font-style:normal}
.sys-offers-details-main-content-info-status3 {color:#fff;padding:2px 10px;border-radius:15px;background:rgb(118, 118, 118);margin-left:2px;font-size:12px;font-style:normal}
.sys-offers-details-main-content-info1 {display:inline-block;margin-right:5%;font-size:13px;line-height:28px}

.sys-offers-details-main .sys-offers-details-imgs {display:flex;align-items: center;justify-content: center;float:left;width:60px;height:60px;border:1px solid #dddddd;border-radius:6px;background:rgba(221,221,221,.4);}
.sys-offers-details-main .sys-offers-details-imgs img {max-width:80%;max-height:80%;border-radius:6px}
.sys-offers-details-main .sys-offers-details-imgs-up {position:absolute;color:#fff;font-size:12px;line-height:13px;background:rgb(103, 194, 58);padding:2px 10px;border-radius:15px;font-style:normal;margin-left:-30px;margin-top:-60px}
.sys-offers-details-main .sys-offers-details-imgs-down {position:absolute;color:#fff;font-size:12px;line-height:13px;background:#909399;padding:2px 10px;border-radius:15px;font-style:normal;margin-left:-30px;margin-top:-60px}
.sys-offers-details-main .sys-offers-details-rights {float:left;margin-left:3%;width:80%}
.sys-offers-details-main .sys-offers-details-rights-sku {font-size:13px;}
.sys-offers-details-main .sys-offers-details-rights-name {float:left;width:100%;font-size:13px;line-height:23px;color:#666666;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.sys-offers-details-main .sys-offers-details-rights-spec {float:left;width:100%;font-size:12px;line-height:23px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.sys-offers-details-main .sys-offers-details-rights-agent {float:left;font-style:normal;padding:0 10px;line-height:18px;border-radius:15px;color:#fff;background:#F56C6C;font-size:12px;margin-top:3px}
.sys-offers-details-main .sys-offers-details-status {float:left;width:100%;font-size:13px;color:#666666;line-height:23px}
.sys-offers-details-main .sys-offers-details-downline-time {float:left;width:100%;font-size:12px;color:#999999;line-height:23px;}

.sys-offers-details-brand-grant-no {font-size:12px;color:#fff;background:#909399;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.sys-offers-details-brand-grant-yes {font-size:12px;color:#fff;background:#67C23A;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.sys-offers-status {font-style:normal;font-weight:550;font-size:14px;color:#F56C6C}
</style>


// WEBPACK FOOTER //
// src/components/mall/Sysoffers.vue